import { type PortableTextComponentProps } from '@portabletext/react'
import {
  type PortableTextListItemBlock,
  type PortableTextMarkDefinition,
  type PortableTextSpan,
} from '@portabletext/types'

type BulletListItemProps = PortableTextComponentProps<
  PortableTextListItemBlock<
    PortableTextMarkDefinition,
    PortableTextSpan,
    string,
    string
  >
>

const BulletListItem = ({ children }: BulletListItemProps) => {
  return <li>{children}</li>
}

export default BulletListItem
